import React, { useState, useEffect } from 'react';
import Button from '../../components/form-elements/Button';

const QuantityInput = ({ initialValue = 1, minValue = 1, maxValue = 100, onChange }) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        if (onChange) {
            onChange(value);
        }
    }, [value, onChange]);

    const increment = () => {
        if (value < maxValue) {
            setValue(prevValue => prevValue + 1);
        }
    };

    const decrement = () => {
        if (value > minValue) {
            setValue(prevValue => prevValue - 1);
        }
    };

    const handleChange = (e) => {
        const newValue = e.target.value;

        if (newValue === '' || !isNaN(newValue)) {
            setValue(newValue === '' ? '' : Math.min(Math.max(Number(newValue), minValue), maxValue));
        }
    };

    const handleBlur = () => {

        if (value === '' || value <= 0) {
            setValue(minValue);
        }
    };

    return (
        <>
            <div className="uk-flex uk-flex-middle">
                <Button
                    modifier="default"
                    className="uk-button uk-button-default custom-button-quantity"
                    onClick={decrement}
                >
                    -
                </Button>
                <input
                    type="number"
                    value={value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="uk-input uk-text-center custom-input-quantity"
                    min={minValue}
                    max={maxValue}
                />
                <Button
                modifier="default"
                    className="uk-button uk-button-default custom-button-quantity"
                    onClick={increment}
                >
                    +
                </Button>
            </div>
        </>
    );
};

export default QuantityInput;
